import { render, staticRenderFns } from "./challenges-slider.vue?vue&type=template&id=913faccc&"
import script from "./challenges-slider.vue?vue&type=script&lang=js&"
export * from "./challenges-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports